export const shareModal = {
  extend: 'ModalWindow',
  tag: 'form',
  ModalHeader: {
    title: 'Share',
    p: 'Share?'
  },
  Flex: {},
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      text: '{{ common.action.share | polyglot }}'
    }
  },
  on: {
    submit: (e, el, s, ctx) => {
      e.preventDefault()
    }
  }
}
